import { storageUrl } from '../../../lib/api.js'
import { formatBytes } from '../../../lib/utils.js'
import { Modal, Badge } from '../../../components/ui/design.jsx'

const MetaRow = ({ label, value, children }) => (
  <>
    <dt className="text-xs font-semibold text-gray-400 uppercase tracking-wide">{label}</dt>
    <dd className="text-gray-900 text-sm">{children ?? value}</dd>
  </>
)

export default function ImagePreviewModal({ image, onClose }) {
  if (!image) return null

  return (
    <Modal onClose={onClose} title={image.title || image.original_name} wide>
      <div className="space-y-4">
        {/* Full image */}
        <div className="overflow-hidden rounded-xl border border-gray-200 bg-gray-50">
          <img
            src={storageUrl(image.url)}
            alt={image.title || image.original_name}
            className="mx-auto max-h-[60vh] w-full object-contain"
            loading="lazy"
          />
        </div>

        {/* Metadata */}
        <dl className="grid grid-cols-2 gap-3 text-sm">
          <MetaRow label="Tipe" value={image.image_type?.name || '—'} />
          <MetaRow label="Status">
            {image.is_active
              ? <Badge variant="active">Aktif</Badge>
              : <Badge>Nonaktif</Badge>}
          </MetaRow>
          <MetaRow label="Nama file" value={image.original_name} />
          <MetaRow label="Ukuran" value={formatBytes(image.size_bytes)} />
          <MetaRow label="Format" value={image.mime_type} />
          <MetaRow label="Urutan" value={image.sort_order} />
          {image.description && (
            <>
              <dt className="text-xs font-semibold text-gray-400 uppercase tracking-wide col-span-2">Keterangan</dt>
              <dd className="text-gray-900 text-sm col-span-2">{image.description}</dd>
            </>
          )}
        </dl>
      </div>
    </Modal>
  )
}
